import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=d400687a"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=d400687a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports